import { InputNumber, Form } from 'antd';

const EditableCell = ({
  editing,
  dataIndex,
  record,
  children,
  onSave,
  onCancel,
  onConfirm,
  ...restProps
}) => {

  const decimalPrecision = [
    'mer_inicial',
    'porcentaje_mer_final',
    'mer_ico_inicial_valor',
    'mer_ico_final_valor'
  ].includes(dataIndex)
    ? 2   
    : 0;

  return (
    <td
      {...restProps}
      onDoubleClick={() => {
        if (!editing && typeof onConfirm === 'function') {
          onConfirm();
        }
      }}
    >
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: false,
              message: 'Ingrese un valor numérico'
            }
          ]}
        >
          <InputNumber
            autoFocus
            style={{ width: '100%' }}
            step={decimalPrecision > 0 ? 0.01 : 1}
            precision={decimalPrecision}
            stringMode={false}
            onPressEnter={() => onSave(record, dataIndex)}
            onBlur={() => onSave(record, dataIndex)}
            onKeyDown={(e) => {
              if (e.key === 'Escape') {
                e.preventDefault();
                onCancel();
              }
            }}
            formatter={(value) => value}
            parser={(value) => value?.replace(',', '.')}
          />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell;